/* eslint-disable max-len */
import { action, flow, makeObservable, observable, toJS } from 'mobx';
import { CourseApi } from '../apis';
import BaseStore from './BaseStore';

class CourseStore extends BaseStore {

    // course by type
    popularCourses = [];
    pagingPopularCourses = {
        ...this.paging,
        page: 1,
        size: 10
    };
    newCourses = [];
    pagingNewCourses = {
        ...this.paging,
        page: 1,
        size: 10,
        sortKey: 'public_date',
        sortDir: 'DESC'
    };

    allCourses = [];
    pagingAllCourses = {
        ...this.paging,
        page: 1,
        size: 10
    }

    lectureByCourse = [];
    pagingLectureListByCourse = {
        ...this.paging,
        page: 1,
        size: 10
    }

    attendanceHistories = [];
    totalStatusApplyAttendance = {};
    selectedAttendances = [];
    pagingAttendanceHistory = {
        ...this.paging,
        page: 1,
        size: 10
    }
    // ei
    attendanceHistoriesEI = [];
    totalStatusApplyAttendanceEI = {};
    selectedAttendancesEI = [];
    pagingAttendanceHistoryEI = {
        ...this.paging,
        page: 1,
        size: 10
    }

    coursDetail = null;

    dataChartCourse = null;

    courseBreadcrumbText = '';

    listCoursePeriod = []

    searchCourseInfo = null;

    testResultHistory = '';

    listCompletionTest = {};

    courseSurvey = {};

    keepTestResultState = {};

    recommendCourses = [];

    pagingRecommendCourses = {
        ...this.paging,
        page: 1,
        size: 15
    }

    isCancelAttendance = false;

    lstTrainingCourse = [];
    lstTrainingCourseGroupedByTicketPlans = [];

    lstTrainingCourseForGA = [];

    pagingTrainingCourseForGA = {
        ...this.paging,
        page: 1,
        size: 10
    }

    lstTicketPlanForGA = [];

    pagingTicketPlanForGA = {
        ...this.paging,
        page: 1,
        size: 10
    }

    // Certificate-download screen (#17889) — students eligible to have their completion
    // certificate downloaded for a given ticket plan, searchable + paginated.
    eligibleStudentsForCertificate = [];
    useEmployeeCodeForCertificate = false;

    pagingEligibleStudentsForCertificate = {
        ...this.paging,
        page: 1,
        size: 10
    }

    lstStudentForTrainingCourse = [];

    pagingStudentForTrainingCourse = {
        ...this.paging,
        page: 1,
        size: 10
    }

    filterStudentOfTrainingCourse = {}

    constructor(rootStore) {
        super();
        makeObservable(this, {
            popularCourses: observable,
            newCourses: observable,
            pagingPopularCourses: observable,
            pagingNewCourses: observable,
            pagingAllCourses: observable,
            allCourses: observable,
            coursDetail: observable,
            lectureByCourse: observable,
            pagingLectureListByCourse: observable,
            dataChartCourse: observable,
            courseBreadcrumbText: observable,
            totalStatusApplyAttendance: observable,
            listCompletionTest: observable,
            courseSurvey: observable,
            keepTestResultState: observable,
            searchCourseInfo: observable,
            recommendCourses: observable,
            isCancelAttendance: observable,
            lstTrainingCourse: observable,
            lstTrainingCourseGroupedByTicketPlans: observable,
            lstTrainingCourseForGA: observable,
            pagingTrainingCourseForGA: observable,
            lstTicketPlanForGA: observable,
            pagingTicketPlanForGA: observable,
            eligibleStudentsForCertificate: observable,
            useEmployeeCodeForCertificate: observable,
            pagingEligibleStudentsForCertificate: observable,
            lstStudentForTrainingCourse: observable,
            pagingStudentForTrainingCourse: observable,
            filterStudentOfTrainingCourse: observable,
            getAllCourses: flow.bound,
            getCourseById: flow.bound,
            getCourseInternalById: flow.bound,
            getListCompletionTest: flow.bound,
            submitCompletionTest: flow.bound,
            getLectureListByCourse: flow.bound,
            getLectureListByCourseInternal: flow.bound,
            getCourseChart: flow.bound,
            studentBuyCourse: flow.bound,
            getAttendingCourseForCancel: flow.bound,
            updateBreadcrumb: action.bound,
            getCoursesByName: flow.bound,
            setSearchCourseInfo: action.bound,
            // attandance history
            getAttendanceHistories: flow.bound,
            getListCoursePeriod: flow.bound,
            exportAttendanceHistories: flow.bound,
            getCourseSurvey: flow.bound,
            sendCourseSurvey: flow.bound,
            cleanAttendanceHistory: action.bound,
            cleanSelectedAttendance: action.bound,
            handleToggleCheckAll: action.bound,
            handleToggleCheckItem: action.bound,
            attendanceHistories: observable,
            selectedAttendances: observable,
            listCoursePeriod: observable,
            pagingAttendanceHistory: observable,
            // attandance history ei
            attendanceHistoriesEI: observable,
            totalStatusApplyAttendanceEI: observable,
            selectedAttendancesEI: observable,
            pagingAttendanceHistoryEI: observable,
            getAttendanceHistoriesEI: flow.bound,
            cleanAttendanceHistoryEI: action.bound,
            // reset
            cleanPagingHomeCourses: action.bound,
            // training course detail for std
            cleanTrainingCourseList: action.bound,
            // training course detail for GA
            clearPagingTrainingCourseForGA: action.bound,
            clearPagingTicketPlanForGA: action.bound,
            clearEligibleStudentsForCertificate: action.bound,
            cleanPagingStudentOfTrainingCourse: action.bound,
            // themes page
            cleanCourseData: action.bound,
            // test result history
            testResultHistory: observable,
            getTestResultHistory: flow.bound,
            cleanRecommendCourses: action.bound,
            // training course
            getTrainingCourseList: flow.bound,
            submitTrainingCourseReport: flow.bound,
            submitTrainingCourseQuestion: flow.bound,
            getTrainingCourseListForGA: flow.bound,
            getTrainingCourseDetailForGA: flow.bound,
            updateSettingsTrainingCourseForGA: flow.bound,
            downloadReportTrainingCourse: flow.bound,
            getTicketPlanListForGA: flow.bound,
            getCompletionSettingsForGA: flow.bound,
            updateCompletionSettingsForGA: flow.bound,
            issueCompletionCertificate: flow.bound,
            getEligibleStudentsForCertificate: flow.bound
        })
        this.rootStore = rootStore;
        this.api = new CourseApi();
    }

    // popular course: 1, new course: 2, taking course: 3
    *getAllCourses(searchParams, type) {
        try {
            const { size, page, sortDir, sortKey } = type === 1 ? this.pagingPopularCourses : type === 2 ? this.pagingNewCourses : type === 3 ? this.pagingRecommendCourses : this.pagingAllCourses;
            const payload = { size, page, sortDir, sortKey, ...searchParams };
            // #18006: the course list has one endpoint per authentication state. The public one always
            // answers as a guest, so a logged-in visitor has to go through the internal one to keep the
            // learner-specific fields (progress, ticket flags, lecture list).
            const isLoggedIn = !!this.rootStore.authStore.token;
            const listApi = isLoggedIn ? this.api.getAllCoursesInternal : this.api.getAllCourses;
            const res = yield this.rootStore.apiStore.call(this.api, listApi, payload);
            if (res?.ok) {
                if (type === 1) {
                    this.popularCourses = res?.data?.elements;
                    this.setAttrObservable('pagingPopularCourses', res?.data?.paginate, true, false);
                } else if (type === 2) {
                    this.newCourses = res?.data?.elements;
                    this.setAttrObservable('pagingNewCourses', res?.data?.paginate, true, false);
                } else if (type === 3) {
                    this.recommendCourses = [...this.recommendCourses, ...(res?.data?.elements ?? [])];
                    this.setAttrObservable('pagingRecommendCourses', res?.data?.paginate, true, false);
                } else {
                    this.allCourses = res?.data?.elements;
                    this.setAttrObservable('pagingAllCourses', res?.data?.paginate, true, false);
                }
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    *getCoursesByName(searchParams) {
        try {
            const payload = { size: -1, page: 1, ...searchParams };
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getCoursesByName, payload, false, null, true);
            return res?.data?.elements || []
        } catch (error) {
            console.log(error);
            return []
        }
    }

    *getCourseById(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getCourseById, payload);
            if (res?.ok) {
                this.coursDetail = res?.data;
                this.courseBreadcrumbText = res?.data?.name;
            }
            return res;
        } catch (error) {
            return error;
        }
    }

    *getCourseInternalById(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getCourseInternalById, payload);
            if (res?.ok) {
                this.coursDetail = res?.data;
            }
            return res;
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    *getListCompletionTest(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getListCompletionTest, payload);
            this.listCompletionTest = res?.data;
            return res?.data;
        } catch (error) {
            console.log(error);
        }
    }

    *getTestResultHistory(courseId) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getTestResultHistory, courseId);
            if (res?.ok) {
                this.testResultHistory = res?.data?.testResultHistory;
            }
            return res;
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    *submitCompletionTest(courseId, payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.submitCompletionTest, { courseId, payload });
            return { ok: !!res?.ok, data: res?.data, message: res?.message };
        } catch (error) {
            console.log(error);
            return { ok: false, data: null, message: error?.message };
        }
    }

    *getLectureListByCourse(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getLectureListByCourse, payload);
            if (res?.ok) {
                this.lectureByCourse = res?.data || {};
                this.setAttrObservable('pagingLectureListByCourse', res?.data?.listLecture?.paginate, true, false);
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getLectureListByCourseInternal(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getLectureListByCourseInternal, payload);
            if (res?.ok) {
                this.lectureByCourse = res?.data || {};
                this.isCancelAttendance = res?.data?.isCancelAttendance || false;
                this.setAttrObservable('pagingLectureListByCourse', res?.data?.listLecture?.paginate, true, false);
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getCourseChart(courseId) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getCourseChart, courseId);
            if (res?.ok) {
                console.log('res:', res);
                this.dataChartCourse = res?.data || {};
            }
        } catch (error) {
            console.log(error);
        }
    }

    *studentBuyCourse(courseId, disableAlertError = false) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api, this.api.studentBuyCourse, courseId, false, null, false, disableAlertError
            );
            return res;
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    *getAttendingCourseForCancel() {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api, this.api.getAttendingCourseForCancel, undefined, false, null, true
            );
            if (res?.ok) {
                return res?.data || null;
            }
            return null;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    updateBreadcrumb(text) {
        this.courseBreadcrumbText = text;
    }

    *getAttendanceHistories(searchParams = {}) {
        try {
            const { size, page, sortDir, sortKey } = this.pagingAttendanceHistory;
            const payload = { size, page, sortDir, sortKey, ...searchParams };
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getAttendanceHistories, payload);
            let selectedAttendances = toJS(this.selectedAttendances);
            if (res?.ok) {
                let data = res?.data?.elements || [];
                // let page = res?.data.paginate?.page || 1;
                data = data.map((item) => {
                    const rowId = page + '.' + item.courseId;
                    // const rowId = item.courseId;
                    const existId = selectedAttendances.find(e => e.rowId === rowId);
                    // return { ...item, rowId: page + '.' + i, isChecked: !!existId }
                    return { ...item, rowId, isChecked: !!existId }
                })
                this.attendanceHistories = data;
                this.setAttrObservable('pagingAttendanceHistory', res?.data?.paginate, true, false);
                this.totalStatusApplyAttendance = res?.data?.total || {};
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    //#region Attandance history ei
    *getAttendanceHistoriesEI(searchParams = {}) {
        try {
            const { size, page, sortDir, sortKey } = this.pagingAttendanceHistoryEI;
            const payload = { size, page, sortDir, sortKey, ...searchParams };
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getAttendanceHistoriesEI, payload);
            let selectedAttendancesEI = toJS(this.selectedAttendancesEI);
            if (res?.ok) {
                let data = res?.data?.elements || [];
                // let page = res?.data.paginate?.page || 1;
                data = data.map((item) => {
                    const rowId = page + '.' + item.courseId;
                    // const rowId = item.courseId;
                    const existId = selectedAttendancesEI.find(e => e.rowId === rowId);
                    // return { ...item, rowId: page + '.' + i, isChecked: !!existId }
                    return { ...item, rowId, isChecked: !!existId }
                })
                this.attendanceHistoriesEI = data;
                this.setAttrObservable('pagingAttendanceHistoryEI', res?.data?.paginate, true, false);
                this.totalStatusApplyAttendanceEI = res?.data?.total || {};
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    cleanAttendanceHistoryEI() {
        this.attendanceHistoriesEI = [];
        this.selectedAttendancesEI = [];
        this.pagingAttendanceHistoryEI = {
            ...this.paging,
            page: 1,
            size: 10
        }
    }
    //#endregion Attandance history ei

    handleToggleCheckAll(event) {
        const val = event.target.checked;
        let selectedAttendances = toJS(this.selectedAttendances);
        let pagingAttendanceHistory = toJS(this.pagingAttendanceHistory);
        let page = pagingAttendanceHistory?.page || 1;
        let attendanceHistories = toJS(this.attendanceHistories);

        if (!val) {
            selectedAttendances = selectedAttendances.filter(e => !e.rowId.includes(page + '.'))
        }

        this.attendanceHistories = [...attendanceHistories].map(item => {
            if (val) {
                const existId = selectedAttendances.find(e => e.rowId === item.rowId);
                if (!existId) {
                    selectedAttendances.push(item);
                }
            }
            return { ...item, isChecked: val }
        })

        this.selectedAttendances = selectedAttendances;
    }

    handleToggleCheckItem(rowId, val) {
        let selectedAttendances = toJS(this.selectedAttendances);
        if (!val) {
            selectedAttendances = selectedAttendances.filter(e => e.rowId !== rowId);
        }

        const attendanceHistories = [...this.attendanceHistories].map(item => {
            if (item.rowId === rowId) {
                if (val) {
                    const existId = selectedAttendances.find(e => e.rowId === rowId);
                    if (!existId) {
                        selectedAttendances.push(item);
                    }
                }
                return { ...item, isChecked: val }
            }
            return item;
        });


        this.attendanceHistories = attendanceHistories;
        this.selectedAttendances = selectedAttendances;
    }

    *getListCoursePeriod(cb) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getListCoursePeriod);
            this.listCoursePeriod = res?.data || [];
            cb && cb(res?.data || []);
            return false;
        } catch (error) {
            console.log(error);
            cb && cb([]);
        }
    }

    *exportAttendanceHistories(payload) {
        try {
            yield this.rootStore.apiStore.call(this.api, this.api.exportAttendanceHistories, payload);
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    *getCourseSurvey(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getCourseSurvey, payload);
            if (res?.ok) {
                this.courseSurvey = res?.data || {};
                return true;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *sendCourseSurvey({ courseId, payload }) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.sendCourseSurvey, { courseId, payload });
            if (res?.ok) {
                return true;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getTrainingCourseList(payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getTrainingCourseList, payload);
            if (res?.ok) {
                this.lstTrainingCourse = Array.isArray(res?.data) ? res.data : (res?.data?.elements || []);
                this.lstTrainingCourseGroupedByTicketPlans = res?.data?.groupedByTicketPlans || [];
                return true;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *submitTrainingCourseReport(id, payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.submitTrainingCourseReport, { id, payload });
            if (res?.ok) {
                return res?.data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *submitTrainingCourseQuestion(id, payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.submitTrainingCourseQuestion, { id, payload });
            if (res?.ok) {
                return true;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getTrainingCourseListForGA(searchParams, hideLoading = false) {
        try {
            const { size, page, sortDir, sortKey } = this.pagingTrainingCourseForGA;
            const payload = { size, page, sortDir, sortKey, ...searchParams };
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getTrainingCourseListForGA, payload, false, null, hideLoading);
            if (res?.ok) {
                this.lstTrainingCourseForGA = res?.data || [];
                this.setAttrObservable('pagingTrainingCourseForGA', res?.data?.paginate, true, false);
                return true;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getTrainingCourseDetailForGA(id, searchParams, hideLoading = false, isDisablePaginate = false) {
        try {
            const { size, page, sortDir, sortKey } = this.pagingStudentForTrainingCourse;
            const payload = isDisablePaginate ? { size: -1, page, sortDir, sortKey, ...searchParams } : { size, page, sortDir, sortKey, ...searchParams };
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getTrainingCourseDetailForGA, { id, payload }, false, null, hideLoading);
            if (res?.ok) {
                if (!isDisablePaginate) {
                    this.lstStudentForTrainingCourse = res?.data || [];
                    this.setAttrObservable('pagingStudentForTrainingCourse', res?.data?.paginate, true, false);
                    this.filterStudentOfTrainingCourse = searchParams;
                }
                return res?.data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *updateSettingsTrainingCourseForGA(id, payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.updateSettingsTrainingCourseForGA, { id, payload });
            if (res?.ok) {
                return true;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *downloadReportTrainingCourse(id, payload) {
        try {
            const res = yield this.rootStore.apiStore.call(this.api, this.api.downloadReportTrainingCourse, { id, payload });
            if (res?.ok) {
                return true;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *issueCompletionCertificate(ticketId) {
        try {
            yield this.rootStore.apiStore.call(this.api, this.api.issueCompletionCertificate, ticketId);
        } catch (error) {
            console.log(error);
        }
    }

    cleanAttendanceHistory() {
        this.attendanceHistories = [];
        this.selectedAttendances = [];
        this.pagingAttendanceHistory = {
            ...this.paging,
            page: 1,
            size: 10
        }
    }

    cleanSelectedAttendance() {
        this.selectedAttendances = [];
    }

    cleanPagingHomeCourses() {
        this.pagingPopularCourses = {
            ...this.paging,
            page: 1,
            size: 10
        };
        this.pagingNewCourses = {
            ...this.paging,
            page: 1,
            size: 10,
            sortKey: 'public_date',
            sortDir: 'DESC'
        };
        this.pagingRecommendCourses = {
            ...this.paging,
            page: 1,
            size: 15
        }
    }

    clearPagingTrainingCourseForGA() {
        this.pagingTrainingCourseForGA = {
            ...this.paging,
            page: 1,
            size: 10
        }
    }

    *getTicketPlanListForGA(searchParams, hideLoading = false) {
        try {
            const { size, page, sortDir, sortKey } = this.pagingTicketPlanForGA;
            const payload = { size, page, sortDir, sortKey, ...searchParams };
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getTicketPlanListForGA, payload, false, null, hideLoading);
            if (res?.ok) {
                this.lstTicketPlanForGA = res?.data || [];
                const paginate = res?.data?.paginate;
                this.setAttrObservable('pagingTicketPlanForGA', {
                    ...(paginate || {}),
                    totalRecord: paginate?.totalRecord || paginate?.total || res?.data?.elements?.length || 0
                }, true, false);
                return true;
            }
        } catch (error) {
            console.log(error);
        }
    }

    clearPagingTicketPlanForGA() {
        this.pagingTicketPlanForGA = {
            ...this.paging,
            page: 1,
            size: 10
        }
    }

    // Certificate-download screen (#17889): searchable/paginated list of students eligible for
    // this ticket plan's completion certificate. `hideLoading` mirrors getTicketPlanListForGA —
    // pass true on paging/search re-fetches so the table's own row-loading state (not the global
    // spinner) is what the screen shows.
    *getEligibleStudentsForCertificate(ticketId, searchParams, hideLoading = false) {
        try {
            const { size, page, sortDir, sortKey } = this.pagingEligibleStudentsForCertificate;
            const payload = { size, page, sortDir, sortKey, ...searchParams };
            const res = yield this.rootStore.apiStore.call(
                this.api, this.api.getEligibleStudentsForCertificate, { ticketId, payload }, false, null, hideLoading
            );
            if (res?.ok) {
                this.eligibleStudentsForCertificate = res?.data?.elements || [];
                if (res?.data?.useEmployeeCode != null) {
                    this.useEmployeeCodeForCertificate = res.data.useEmployeeCode;
                }
                this.setAttrObservable('pagingEligibleStudentsForCertificate', res?.data?.paginate, true, false);
                return true;
            }
        } catch (error) {
            console.log(error);
        }
        return false;
    }

    clearEligibleStudentsForCertificate() {
        this.eligibleStudentsForCertificate = [];
        this.useEmployeeCodeForCertificate = false;
        this.pagingEligibleStudentsForCertificate = {
            ...this.paging,
            page: 1,
            size: 10
        }
    }

    *getCompletionSettingsForGA(ticketId) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api, this.api.getCompletionSettingsForGA, { ticketId }
            );
            if (res?.ok) {
                // Fetched once per screen mount — cheaper to cache it here than to have the
                // (paginated, re-fetched on every search/page change) eligible-students response
                // repeat it, so the certificate-download screen's 社員番号 column/filter reads
                // this observable instead.
                if (res?.data?.useEmployeeCode != null) {
                    this.useEmployeeCodeForCertificate = res.data.useEmployeeCode;
                }
                return res?.data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *updateCompletionSettingsForGA(ticketId, payload) {
        try {
            const res = yield this.rootStore.apiStore.call(
                this.api, this.api.updateCompletionSettingsForGA, { ticketId, payload }
            );
            if (res?.ok) {
                return true;
            }
        } catch (error) {
            console.log(error);
        }
    }

    cleanPagingStudentOfTrainingCourse() {
        this.pagingStudentForTrainingCourse = {
            ...this.paging,
            page: 1,
            size: 10
        }
    }

    cleanRecommendCourses() {
        this.recommendCourses = [];
    }

    cleanCourseData() {
        this.allCourses = [];
        this.pagingAllCourses = {
            ...this.paging,
            page: 1,
            size: 10
        }
    }

    cleanTrainingCourseList() {
        this.lstTrainingCourse = [];
        this.lstTrainingCourseGroupedByTicketPlans = [];
    }

    setSearchCourseInfo(name) {
        this.searchCourseInfo = name;
    }
}

export default CourseStore;